import store from "@/store";
import { createRouter, createWebHistory, RouteRecordRaw, Router } from "vue-router";
import Layout from "@/views/layout/index.vue";
// 静态路由
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: { path: "/login" },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/auth/login/index.vue"),
    meta: { title: "登录", keepAlive: false },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404.vue"),
    meta: { title: "404", keepAlive: false },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/layout/index.vue"),
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "/Commodityallocation/stock/details",
        name: "添加详情",
        component: () => import("@/views/Commodityallocation/stock/details/index.vue"),
      },
      {
        path: "/Staffmanagement/Role/addrole",
        name: "添加角色",
        component: () => import("@/views/Staffmanagement/Role/addrole/index.vue"),
      },
      {
        path: "/Staffmanagement/Role/Addemployee",
        name: "添加职员",
        component: () => import("@/views/Staffmanagement/Role/Addemployee/index.vue"),
      },
      {
        path: "/Merchantmenu/zht/zhttow",
        name: "主后台二级",
        component: () => import("../views/Merchantmenu/zht/zhttow/index.vue"),
      },
      {
        path: "/Merchantmenu/zht/zhtthree",
        name: "主后台三级",
        component: () => import("../views/Merchantmenu/zht/zhtthree/index.vue"),
      },
      {
        path: "/Merchantmenu/md/mdtow",
        name: "门店二级",
        component: () => import("../views/Merchantmenu/md/mdtow/index.vue"),
      },
      {
        path: "/Merchantmenu/md/mdthree",
        name: "门店三级",
        component: () => import("../views/Merchantmenu/md/mdthree/index.vue"),
      },
    ],
  },
];

// export interface IRoute extends Router {
//   isBack?: boolean;
// }

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const flag = true;
router.beforeEach((to: any, from: any, next: any) => {
  const Token = localStorage.getItem("token");
  if (!Token) {
    if (to.path == "/login") {
      next();
    } else {
      next("/");
    }
  } else {
    if (to.path == "/login") {
      localStorage.removeItem("asyncRouterMap");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      sessionStorage.removeItem("selectData");
      // location.reload();
      store.dispatch("SET_USER_ROUTER", []);
      router.replace({ path: "/login" });
      location.reload();
      return;
    } else {
      // console.log("刷新添加路由");
      reSetPermissionList(to).then((data) => {
        data === "permCode" ? next({ path: to.path, query: to.query }) : next();
      });
    }
  }
});
const reSetPermissionList = (to: any) => {
  console.log(to);
  if (to.matched.length == 0) {
    // 没有该动态路由跳转404
    router.push("/404");
  }
  return new Promise((resolve, reject) => {
    if (to.path !== "/login" && store.state.routerArr.length === 0) {
      console.log(store.state.routerArr.length);
      addRouter();
      resolve("permCode");
    } else {
      addRouter();
      resolve("");
    }
  });
};
// 动态路由添加异步加载  使用Promise   由于vue示例同步挂载，addrouter为异步
const addRouter = () => {
  const asyncRouterMap = JSON.parse(localStorage.getItem("asyncRouterMap") as string);
  console.log(asyncRouterMap);

  if (asyncRouterMap) {
    asyncRouterMap.forEach((item: any) => {
      item.component = Layout;
    });
    // 默认路由
    const currenRoutes = router.options.routes as any;
    // 动态路由添加
    asyncRouterMap.forEach((item: any) => {
      // has用于判断当前路由中是否已经具有，避免重复
      const has = currenRoutes.some((it: any) => it.path == item.path);
      if (!has) {
        currenRoutes.push(item as any);
      }
    });
    currenRoutes.forEach((item: any) => {
      if (item.children) {
        item.children.forEach((item2: any) => {
          item2.component = () => import(`@/views${item2.path}/index.vue`);
          router.addRoute(item2);
        });
      }
      router.addRoute(item);
    });
    store.dispatch("SET_USER_ROUTER", currenRoutes);
    store.dispatch("ASYNC_ROUTER_MARK", true);
    console.log("当前路由", currenRoutes);
  }
};
// 防止重复路由添加
const repeatRouter = (arr: any) => {
  arr.forEach((item: any) => {
    const currenRoutes = router.options.routes as any;
    const has = currenRoutes.some((it: any) => it.path == item.path);
    if (item.children) {
      repeatRouter(item.children);
    } else {
      if (!has) {
        currenRoutes.push(item as any);
      }
    }
  });
};
export default router;
